"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var React = _interopRequireWildcard(require("react"));

var _ListTree = _interopRequireDefault(require("./ListTree"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ListTreeGroup = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(ListTreeGroup, _React$Component);

  var _super = _createSuper(ListTreeGroup);

  function ListTreeGroup() {
    var _this;

    (0, _classCallCheck2["default"])(this, ListTreeGroup);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      collapsesOpened: _this.props.collapsesOpened
    });
    return _this;
  }

  (0, _createClass2["default"])(ListTreeGroup, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          list = _this$props.list,
          separator = _this$props.separator,
          globalOnClick = _this$props.globalOnClick,
          onFavorite = _this$props.onFavorite;
      var multipleList = list.length > 1;
      return /*#__PURE__*/React.createElement("div", {
        className: "pp-nested-list"
      }, list.map(function (list, index) {
        return /*#__PURE__*/React.createElement(_ListTree["default"], (0, _extends2["default"])({
          collapsesOpened: _this2.state.collapsesOpened,
          key: index,
          separator: separator,
          globalOnClick: globalOnClick,
          onFavorite: onFavorite,
          multipleList: multipleList
        }, list));
      }));
    }
  }]);
  return ListTreeGroup;
}(React.Component);

ListTreeGroup.defaultProps = {
  list: [],
  collapsesOpened: 1,
  separator: false
};
var _default = ListTreeGroup;
exports["default"] = _default;